import { Link } from "react-router-dom";
import { Truck, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL_LINK, EMAIL, EMAIL_LINK, WHATSAPP_LINK } from "@/constants/business";

const SERVICE_LINKS = [
  { label: "Transport de meubles", href: "/transport-de-meubles" },
  { label: "Déménagement", href: "/petit-demenagement" },
  { label: "Électroménager", href: "/transport-electromenager" },
  { label: "Camion avec chauffeur", href: "/camion-avec-chauffeur" },
  { label: "Groupage", href: "/groupage-transport" },
  { label: "Longue distance", href: "/transport-longue-distance" },
  { label: "Débarras", href: "/debarras" },
  { label: "Livraison Leboncoin / Marketplace", href: "/livraison-leboncoin-marketplace" },
];

const ZONE_LINKS = [
  { label: "Le Havre", href: "/transport-le-havre" },
  { label: "Rouen", href: "/transport-rouen" },
  { label: "Caen", href: "/transport-caen" },
  { label: "Dieppe", href: "/transport-dieppe" },
  { label: "Fécamp", href: "/transport-fecamp" },
  { label: "Paris", href: "/transport-paris" },
  { label: "Normandie", href: "/transport-normandie" },
];

const INFO_LINKS = [
  { label: "Mentions légales", href: "/mentions-legales" },
  { label: "Confidentialité", href: "/politique-de-confidentialite" },
  { label: "Cookies", href: "/politique-cookies" },
  { label: "Conditions générales", href: "/conditions-generales" },
  { label: "Réclamations", href: "/reclamations" },
  { label: "Plan du site", href: "/plan-du-site" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white pt-14 pb-28 md:pb-10 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="sm:col-span-2 lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="bg-orange text-white rounded-xl p-2">
              <Truck className="w-5 h-5" />
            </span>
            <span className="font-heading font-extrabold text-xl">Express Delivery</span>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed mb-5">
            Transport, déménagement, groupage et longue distance depuis Le Havre et sa région.
          </p>
          <div className="flex flex-col gap-2.5 text-sm">
            <a href={PHONE_TEL_LINK} data-testid="footer-phone-link" className="flex items-center gap-2 text-white/80 hover:text-orange transition-colors">
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
            <a href={EMAIL_LINK} data-testid="footer-email-link" className="flex items-center gap-2 text-white/80 hover:text-orange transition-colors">
              <Mail className="w-4 h-4" /> {EMAIL}
            </a>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2 text-white/80 hover:text-orange transition-colors">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <span className="flex items-center gap-2 text-white/60">
              <Clock className="w-4 h-4" /> Du lundi au samedi — réponse rapide par téléphone ou WhatsApp
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/50 mb-4">Services</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {SERVICE_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} data-testid={`footer-service-${link.href.slice(1)}`} className="text-white/75 hover:text-orange transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/50 mb-4">Zones</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {ZONE_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} data-testid={`footer-zone-${link.href.slice(1)}`} className="text-white/75 hover:text-orange transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-white/50 mb-4">Informations</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {INFO_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} data-testid={`footer-info-${link.href.slice(1)}`} className="text-white/75 hover:text-orange transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto border-t border-white/10 mt-12 pt-6 text-xs text-white/45 space-y-1.5">
        <p>© {new Date().getFullYear()} Express Delivery. Tous droits réservés.</p>
        <p>Site et contenus protégés. Toute reproduction non autorisée est interdite.</p>
        <p>Express Delivery est un service indépendant et n'est pas affilié aux plateformes de vente entre particuliers citées (Leboncoin, Facebook Marketplace).</p>
      </div>
    </footer>
  );
}
